<template>
    <c-dialog ref="dialog" title="提现申请详情" mode="slide" width="70vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.apply_no" class="m-detail-tag flex-center-cross">
                <c-state tag async dict="WITHDRAW_STATUS" :value="detailData.withdraw_status"></c-state>
                <label>{{detailData.apply_no}}</label>
            </div>
        </template>

        <module>
            <module-col size="400">
                <c-detail class="m-detail-form">
                    <c-detail-item label="提现账户">
                        <c-state tag async dict="ACCOUNT_TYPE" :value="detailData.withdraw_account_type"></c-state>
                    </c-detail-item>
                    <c-detail-item label="支付渠道">
                        <c-state async tag dict="CHECK_PAYMENT_CHANNEL" :value="detailData.check_payment_channel"></c-state>
                    </c-detail-item>
                    <c-detail-item label="提现申请单号">
                        {{detailData.apply_no}}
                    </c-detail-item>
                    <c-detail-item label="提现状态">
                        <c-state tag async dict="WITHDRAW_STATUS" :value="detailData.withdraw_status"></c-state>
                    </c-detail-item>
                    <c-detail-item label="提现金额">
                        ￥{{detailData.withdraw_amount}}
                    </c-detail-item>
                    <c-detail-item label="提现申请人">
                        {{detailData.user_realname||'-'}}
                    </c-detail-item>
                    <c-detail-item label="提现申请时间">
                        {{detailData.create_date||'-'}}
                    </c-detail-item>
                    <c-detail-item label="审批人">
                        {{detailData.audit_user_realname||'-'}}
                    </c-detail-item>
                    <c-detail-item label="审批驳回原因" v-show="detailData.withdraw_status == 6">
                        <span style="color: red">{{detailData.reject_reason||'-'}}</span>
                    </c-detail-item>
                    <c-detail-item label="审批时间">
                        {{detailData.audit_time||'-'}}
                    </c-detail-item>
                    <c-detail-item label="打款凭证" v-if="detailData.pay_voucher_img_url">
                        <c-file  v-if="detailData.pay_voucher_img_url" :src="img.pay_voucher_img_url" media></c-file>
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <module-tab name="提现商品明细" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="productListTable" :data="productList" border :paging="false">
                            <c-table-column
                                    label="商品信息"
                                    width="230"
                            >
                                <template #default="{data}">
                                    {{getProductText(data)}}
                                </template>
                            </c-table-column>
                            <c-table-column
                                    name="produce_unique_code"
                                    label="背贴码"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="produce_imei"
                                    label="IMEI"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="order_no"
                                    label="小黑订单号"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column label="销售货款" width="100">
                                <template #default="{data}">
                                    <span style="color: green">￥{{data.check_product_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="退款金额" width="100">
                                <template #default="{data}">
                                    <span style="color: red">￥{{data.check_return_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="补差金额" width="100">
                                <template #default="{data}">
                                    <span style="color: red">￥{{data.check_supplement_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="结算金额" width="100">
                                <template #default="{data}">
                                    <strong v-if="data.check_receipt_money > 0" style="color: green">￥{{data.check_receipt_money||0}}</strong>
                                    <strong v-if="data.check_receipt_money <= 0" style="color: red">￥{{data.check_receipt_money||0}}</strong>
                                </template>
                            </c-table-column>
                            <c-table-column
                                    name="order_create_date"
                                    label="下单日期"
                                    width="130"
                            >
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>
    </c-dialog>
</template>

<script>

export default {
    name: 'saasWithdrawApplyDetail',

    components: {
    },

    props: {
        id: [String, Number]
    },

    data() {
        return {
            workType: 2,
            detailData: {},
            productList:[]
        }
    },

    computed: {
    },

    methods: {
        /**
         * 加载详情
         */
        detail(){
            this.request({
                url:'/withdraw/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailData;
                    this.productList = data.productList||[];
                }
            });
        },
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },

        open() {
            this.detail();
            this.$refs.dialog.open();
        }
    }
}
</script>

<style lang="stylus" scoped>
.logs-list {
    padding: 10px 10px;

    li {
        padding: 4px 0;
        line-height: 16px;
        font-size: 13px;
        color: #666;
    }
}
</style>